import React from 'react'

import Select from 'react-select'

import { func, bool, shape, string } from 'prop-types'

function Units({
  printableTechDetails = {
    units: null,
  },
  onDetailsChange: handleDetailChange,
  showErrors = false,
}) {
  // eslint-disable-next-line no-undef
  const options = I18n.translate('publisher.units')

  if (!options) {
    return null
  }

  return (
    <div className="col-12 col-sm-6 col-md-3 col-xl-2">
      <div className="section-heading--small u-mb10">Units <b>*</b></div>
      <Select
        id="units"
        className={`Select-outline ${showErrors && printableTechDetails.units === null ? 'is-invalid' : ''}`}
        placeholder="Choose units"
        options={options}
        onChange={(data) => handleDetailChange('units', data.value)}
        value={printableTechDetails.units}
        searchable={false}
        clearable={false}
      />
      {showErrors && printableTechDetails.units === null && (
        <div className="error-message">Units are required</div>
      )}
    </div>
  )
}

Units.propTypes = {
  onDetailsChange: func.isRequired,
  showErrors: bool,
  printableTechDetails: shape({
    units: string,
  }),
}

export default Units
